<template>
  <div>
    <div class="text-center" v-if="loading">
      <b-spinner class="ms-2" variant="primary"></b-spinner>
    </div>
    <div class="col-md-12" v-else>
      <div class="row">
        <div class="col-md-3">
          <b-form-group label="Cooperado">
            <multiselect
              label="name"
              track-by="name"
              select-label=""
              :taggable="false"
              :max-height="200"
              :allowEmpty="false"
              :options="cooperadoLkp"
              placeholder="Selecione"
              v-model="selecaoCooperado"
              :disabled="disabledCooperado"
            >
              <span slot="noOptions">Nenhum Cooperado disponível</span>
            </multiselect>
          </b-form-group>
        </div>
        <div class="col-md-3">
          <cpfCnpjInput
            :required="true"
            v-model="cpfCnpj"
            :submitted="submit"
            :state="cpfCnpjState"
            :disabled="disabledCpfCnpj || disabledAddCpfCnpj"
            placeholder="Digite CPF ou CNPJ"
            @update:isValid="handleValidState"
            :error-message="mensagemErro || undefined"
            :input-class="disabledCpfCnpj ? 'bg-white opacity-50' : ''"
          />
        </div>

        <div class="col-md-3">
          <b-form-group class="mb-3" label="Nome Completo/Razão Social">
            <b-input-group>
              <b-form-input
                class="rounded"
                :state="state('clienteRural')"
                :disabled="disabledAddCpfCnpj"
                type="text" v-model="clienteRural"
                placeholder="Digite o nome completo"
                />
              <b-input-group-append>
                <b-spinner v-if="loadingCpfCnpj" small variant="success" />
              </b-input-group-append>
            </b-input-group>
            <b-form-invalid-feedback :state="state('clienteRural')">
              Nome Completo/Razão Social é obrigatório.
            </b-form-invalid-feedback>
          </b-form-group>
        </div>

        <div class="col-md-3">
          <b-form-group class="mb-3" label="Data de Nascimento">
            <b-input-group>
              <date-picker
                append-to-body
                format="DD/MM/YYYY"
                value-type="YYYY-MM-DD"
                v-model="dataNascimento"
                :disabled="disabledAddCpfCnpj"
              />
              <b-input-group-append>
                <b-spinner v-if="loadingCpfCnpj" small variant="success" />
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </div>
      </div>
    </div>
      <div class="col-md-12 d-flex justify-content-end">
        <b-button
            variant="success"
            class="mt-1 me-1"
            data-tooltip="Salvar"
            @click="salvarDadosPessoais"
            data-tooltip-location="left"
            :disabled="!habilitaBotaoSalvar || loadingSalvar"
        >
          <i class="mdi mdi-content-save"></i>
          <b-spinner class="ms-2" small variant="primary" v-if="loadingSalvar"></b-spinner>
        </b-button>
      </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import { required } from "vuelidate/lib/validators";
import cpfCnpjInput from "../formulario/cpfCnpj-input.vue";
import clienteRuralMixin from "@/tools/mixins/clienteRuralMixin.js";

export default {
  mixins: [clienteRuralMixin],
  components: {
    Multiselect,
    cpfCnpjInput
  },

  props: {
    fotoPerfil: {
      type: Object,
      required: true,
      default: () => ({
        base64: null,
        file: null,
        base64Completo: null,
        nomeArquivo: null
      })
    }
  },

  data() {
    return {
      loading: true,
      cpfCnpj: "",
      submit: false,
      errorMessage: "",
      clienteRural: "",
      cooperadoLkp: [],
      mensagemErro: '',
      modoEdicao: false,
      cpfCnpjState: null,
      dataNascimento: "",
      clienteRuralLkp: [],
      preencheInput: null,
      debounceTimer: null,
      loadingSalvar: false,
      loadingCpfCnpj: false,
      selecaoCooperado: null,
      disabledCpfCnpj: false,
      disabledAddCpfCnpj: false,
      disabledCooperado: false,
      fotoLocal: null,
      localFotoPerfil: {
        type: Object,
        required: true,
        default: () => ({
          base64: null,
          file: null,
          base64Completo: null,
          nomeArquivo: null
        })
      },
      isBuscandoGePessoaExecuting: false,
      isFiltrarClienteRuralExecuting: false,
    };
  },

  watch: {
    selecaoCooperado() {
      if (this.selecaoCooperado) {
        this.buscaClienteRuralProjetos(this.selecaoCooperado.value);
      }
    },

    cpfCnpj(newValue) {
      this.debouncedCpfCnpjChange(newValue);
    },

    fotoPerfil: {
      deep: true,
      immediate: true
    }
  },

  computed: {
    habilitaBotaoSalvar() {
      const camposPreenchidos =
        this.cpfCnpj &&
        this.cpfCnpjState !== false &&
        this.clienteRural.trim() !== "";
      const validacaoOk = !this.$v.$invalid;
      return camposPreenchidos && validacaoOk;
    }
  },
  async created() {
    await this.buscarLkpCooperado();
    const cooperadoLkp = this.$store.state.filtroClienteRuralAstec.cdCooperado;
    this.selecaoCooperado = this.cooperadoLkp.find((el) => el.value === cooperadoLkp);
    this.disabledCooperado = false;
    this.disabledCpfCnpj = false;
    this.localFotoPerfil = { ...this.fotoPerfil };
    this.debouncedCpfCnpjChange = this.debounce(this.onCpfCnpjChanged, 500);
    if (this.$store.state.clienteRuralAstec) {
      this.modoEdicao = true;
      this.$emit("modoEdicaoAtivo", true);
      const cooperadoLkpEditando = this.$store.state.filtroClienteRuralAstec.cdCooperado;
      this.selecaoCooperado = this.cooperadoLkp.find((el) => el.value === cooperadoLkpEditando);
      this.disabledCooperado = true;
      this.cpfCnpj = this.$store.state.clienteRuralAstec.NRCPFCNPJ ?? null;
      this.disabledCpfCnpj = true;
      this.clienteRural = this.$store.state.clienteRuralAstec.NMRAZAO ?? null;
      if (this.$store.state.clienteRuralAstec.DTNASCIMENTO) {
        const data = this.$store.state.clienteRuralAstec.DTNASCIMENTO;
        const [dia, mes, ano] = data.split('/');
        this.dataNascimento = `${ano}-${mes}-${dia}`;
      }
      const sqClienteRural = this.$store.state.clienteRuralAstec.SQCLIENTE ?? null;
      if (sqClienteRural) {
        await this.carregarFotoDoCliente(sqClienteRural);
      } else {
        this.usarFotoPadrao()
      }
    }
    this.loading = false;
  },

  methods: {
    state(param) {
      if (this.submit) {
        if (param === 'cpfCnpj') {
          const isRequiredValid = !this.$v.cpfCnpj.$invalid;
          if (!isRequiredValid) {
            return false;
          }
          return null;
        }
        return !this.$v[param].$invalid;
      } else {
        return null;
      }
    },

    async carregarFotoDoCliente(sqCliente) {
      try {
        const fotoBase64 = await this.getClienteRuralFoto(sqCliente);

        if (fotoBase64 && fotoBase64.startsWith('data:image')) {
          this.fotoPerfil = {
            file: null,
            base64: fotoBase64.split(',')[1],
            base64Completo: fotoBase64,
            nomeArquivo: `cliente_${sqCliente}.webp`
          };
          this.$emit('updateFotoPerfil', this.fotoPerfil);

        } else {
          this.usarFotoPadrao();
        }
      } catch (error) {
        this.usarFotoPadrao();
      }
    },

    usarFotoPadrao() {
      console.log('Usando foto padrão');
    },
    async salvarDadosPessoais() {
      try {
        this.loadingSalvar = true;
        this.submit = true;

        this.$v.$touch();
        if (this.$v.$invalid || this.cpfCnpjState === false) {
          this.loadingSalvar = false;
          return;
        }

        const dadosCliente = {
          nm_razao: this.clienteRural,
          cd_cooperado: this.selecaoCooperado?.value || '',
          dataNascimento: this.dataNascimento
            ? new Date(this.dataNascimento).toISOString().slice(0, 19).replace('T', ' ') : null,
          nr_cpf_cnpj: this.cpfCnpj.replace(/\D/g, ''),
        };

        const formData = new FormData();
        formData.append('dados_cliente', JSON.stringify(dadosCliente));
        Object.keys(dadosCliente).forEach(key => {
          const value = dadosCliente[key] === null ? '' : dadosCliente[key];
          formData.append(key, value);
        });

        if (this.fotoPerfil && (this.fotoPerfil.file || this.fotoPerfil.base64)) {
          if (this.fotoPerfil.file) {
            formData.append('foto', this.fotoPerfil.file);
            formData.append('nm_caminho_foto', this.fotoPerfil.file);
          } else if (this.fotoPerfil.base64) {
            try {
              const base64Data = this.fotoPerfil.base64.startsWith('data:image')
                ? this.fotoPerfil.base64
                : `data:image/jpeg;base64,${this.fotoPerfil.base64}`;

              const blob = this.base64ToBlob(base64Data);
              const fileName = this.fotoPerfil.nomeArquivo || 'foto_perfil.jpg';

              formData.append('foto', blob, fileName);
              formData.append('nm_caminho_foto', blob, fileName);
            } catch (error) {
              console.error("Erro ao converter base64:", error);
            }
          }
        } else {
          console.log("Não tem foto para enviar");
        }
        for (let [key, value] of formData.entries()) {
          if (key === 'foto' || key === 'nm_caminho_foto') {
            console.log(key, value instanceof File ? value.name : 'Blob/File');
          } else {
            console.log(key, value);
          }
        }

        const config = {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          timeout: 30000
        };
        const response = await this.$http.post("api/astec/insertClienteRural", formData, config);
        if (response.data) {
          this.$store.commit("CLIENTE_RURAL_ASTEC", response.data);
        }

        if (dadosCliente.nm_razao) {
          this.$emit('insertNomeClienteRural', dadosCliente.nm_razao);
          this.$emit('enableTab', 'contatos');
        }

        this.$tools.alerta("Dados salvos com sucesso", "success");
        this.disabledCpfCnpj = true;

      } catch (err) {
        console.error("Erro na requisição:", err);

        if (err.response) {
          console.error("Response error:", err.response.data);
          console.error("Response status:", err.response.status);
          console.error("Response headers:", err.response.headers);
        }

        const errorMessage = err.response?.data?.message
          || err.response?.data?.error
          || err.message
          || "Erro ao salvar os dados";

        this.$tools.alerta(errorMessage, "error");

      } finally {
        this.loadingSalvar = false;
      }
    },

    receberFotoParaSalvamento(novaFoto) {
      this.fotoLocal = {
        ...novaFoto
      };
    },

    enviarFotoParaPai(novaFoto) {
      this.$emit('updateFotoPerfil', novaFoto);
    },

  base64ToBlob(base64) {
    try {
      if (!base64) {
        throw new Error("Base64 está vazio ou undefined");
      }

      const parts = base64.split(';base64,');
      if (parts.length < 2) {
        throw new Error("Formato base64 inválido");
      }

      const contentType = parts[0].split(':')[1];
      const raw = window.atob(parts[1]);
      const uInt8Array = new Uint8Array(raw.length);

      for (let i = 0; i < raw.length; ++i) {
        uInt8Array[i] = raw.charCodeAt(i);
      }

      return new Blob([uInt8Array], { type: contentType });
    } catch (error) {
      console.error("Erro na conversão base64 para blob:", error);
      throw error;
    }
  },

    async buscaClienteRuralProjetos(codCooperado) {
      const response = await this.$http.get("/api/astec/getLkpClienteRuralProjetos/" + codCooperado);
      this.clienteRuralLkp = response.data.map(cliente => {
        return {
          name: cliente.DISPLAY,
          value: cliente.ID,
          cpfCnpj: cliente.NRCPFCNPJ,
        };
      });
    },

    async filtarClienteRural(valueCpfCnpj) {
      if (this.isFiltrarClienteRuralExecuting || this.isBuscandoGePessoaExecuting) return;
      this.isFiltrarClienteRuralExecuting = true;

      const apenasNumeros = valueCpfCnpj.replace(/\D/g, '');

      const clienteFiltrado = this.clienteRuralLkp.find(cliente => {
        if (cliente.cpfCnpj) {
          const cpfCnpjCliente = cliente.cpfCnpj.replace(/\D/g, '');
          return cpfCnpjCliente === apenasNumeros;
        } else {
          return false;
        }
      });

      if (clienteFiltrado) {
        const filtro = {
          cdCooperado: this.selecaoCooperado?.value ?? '',
          sqCliente: clienteFiltrado.value,
          mes_aniversario: "",
          e_mail: "",
          sq_regiao: null,
          cd_projeto: null,
          safra: null
        };
        await this.buscarItens(filtro);
      }
      this.isFiltrarClienteRuralExecuting = false;
    },

    async buscarItens(filtroCliente) {
      try {
        if (this.clienteRural.trim() !== "") return;
        const response = await this.$http.post("/api/astec/getClienteRuralLista", filtroCliente);
        if (response.data) {
          this.$tools.alerta("Este Cliente Rural já está cadastrado em sua carteira de clientes. Utilize o filtro para realizar as manutenções cadastrais.", "warning");
          await new Promise(resolve => {
            const swalContainer = document.querySelector('.swal2-container');
            if (swalContainer) {
              const observer = new MutationObserver(() => {
                const stillExists = document.querySelector('.swal2-container');
                if (!stillExists) {
                  observer.disconnect();
                  resolve();
                }
              });
              observer.observe(document.body, { childList: true, subtree: true });
            } else {
              setTimeout(resolve, 4000);
            }
          });
          this.handleValidState(false, true);
          this.$forceUpdate();
          this.disabledAddCpfCnpj = true;
        }
      } catch (error) {
        console.error("Erro ao buscar os contatos:", error);
        this.$tools.alerta(error.response?.data?.message || "Erro desconhecido", "error");
      } finally {
        this.loadingTabela = false;
      }
    },

    async buscaTableGePessoa(filtroCliente) {
      if (this.isBuscandoGePessoaExecuting || this.isFiltrarClienteRuralExecuting) return;
      this.isBuscandoGePessoaExecuting = true;

      try {
        this.loadingCpfCnpj = true;
        let clienteCpfCnpj = filtroCliente.replace(/\D/g, '');
        if (this.clienteRural.trim() !== "") return;
        const response = await this.$http.get(`/api/astec/getTableGePessoa/${clienteCpfCnpj}`);
        this.preencheInput = response.data;
        this.preencherCampos();
      }
      finally {
        this.loadingCpfCnpj = false;
        this.isBuscandoGePessoaExecuting = false;
      }
    },

    debounce(func, wait) {
      let timeout;
      return function (...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          func.apply(this, args);
        }, wait);
      };
    },

    onCpfCnpjChanged(value) {
      const apenasNumeros = value.replace(/\D/g, '');
      if (apenasNumeros.length < 11) {
        return;
      }
      if (apenasNumeros.length === 11 || apenasNumeros.length === 14) {
        if (!this.loadingCpfCnpj) {
          this.filtarClienteRural(apenasNumeros);
          this.buscaTableGePessoa(apenasNumeros);
        }
      }
    },

    preencherCampos() {
      if (!this.preencheInput) return;
      this.clienteRural = this.preencheInput.nm_razao ?? ""
      const data = this.preencheInput.dt_nasc ?? ""
      if (data) {
        const [dia, mes, ano] = data.split('/');
        this.dataNascimento = `${ano}-${mes}-${dia}`;
      }
    },

    handleValidState(isValid, fromApi = false) {
      if (isValid === false) {
        this.cpfCnpjState = false;
        this.mensagemErro = fromApi ? 'CPF / CNPJ já cadastrado.' : 'CPF / CNPJ inválido.';
      } else {
        this.cpfCnpjState = true;
        this.mensagemErro = null;
      }
    },
  },
  validations: {
    cpfCnpj: { required, },
    clienteRural: { required, }
  },
};
</script>

<style lang="scss" scoped>
.input-group-append {
  right: 3%;
  height: 100%;
  display: flex;
  position: absolute;
  align-items: center;
}
</style>
